// This is legacy file. It was used before app #8.  Starting app #8, products.products is used
import { make } from 'vuex-pathify'
import rpc from '../../api/rpc'

const state = {
  products: null
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  setProducts ({ commit }, value) {
    commit('SET_PRODUCTS', value)
  },

  async productsFetch ({ rootState, dispatch }) {
    const response = await rpc('products.products_fetch', { org_id: ((rootState.authorizedUser || {}).currentOrgObject || {}).id, app_id: ((rootState.authorizedUser || {}).currentAppObject || {}).id })
    if (response) {
      dispatch('setProducts', response)
      return true
    }
  },

  async productsView ({ commit, state, dispatch, rootState, getters, rootGetters }, id) {
    if (state.products === null) await dispatch('productsFetch')
    const product = state.products.find(r => r.id === id)
    dispatch('currentProduct/setCurrentProduct', product, { root: true })
    return true
  },

  async productsDelete ({ commit, state }, id) {
    const response = await rpc('products.products_delete', id)
    if (response && response.result === 'Success') {
      commit('SET_PRODUCTS', state.products.filter(r => r.id !== id))
      return true
    }
  }
}

export default { state, actions, mutations, namespaced }
